import React from 'react';
// import {
// 	Route,
// 	Link
// } from 'react-router-dom';
import './resources.scss';
import { Carousel } from 'antd';
// import ajax from '@/api/public';

class Resource extends React.Component{
	constructor (props) {
		super(props)
		this.state={

		}
	}
    componentDidMount (){
        document.getElementById('app').scrollIntoView(true)
    }
	render() {
		return(
			<div className="resource-child">
			<div className='weidai'>
				<div className='common-head home-contain'>
					<a href='#/resource' className="mianbaoxie">流量资源</a>  <i className='glyphicon glyphicon-toright'></i> <span>社交广告</span>
				</div>
				<div className='common-title minWith' style={{marginBottom: '24px'}}>什么是社交广告？</div>
				<div className='text-center minWith'>腾讯社交广告是由腾讯公司推出的效果广告系统。它是国内领先的效果广告营销平台，依托于腾讯海量优质流量资源，</div>
				<div className='text-center minWith'>给广告主提供跨平台、跨终端的网络推广方案，并利用腾讯大数据处理算法实现成本可控、效果客观、智能投放的互联网效果广告平台。</div>
				<div className='text-title text-center minWith'>您的广告可以展示在这里</div>

				<div className='home-contain' style={{paddingBottom: '50px'}}>
                    <span className='second-title' style={{margin: '36px 0 20px 0'}}>朋友圈广告</span>
					<div className='home-contain text-contain'>
						<div className='text-center' style={{position: 'relative'}}>
							<img className='block-center' src={`${process.env.PUBLIC_URL}/images/sj1.png`} />
						</div>
                        <span className='second-title' style={{margin: '36px 0 20px 0'}}>导航广告</span>
						<div className='text-center' style={{position: 'relative'}}>
							<img className='block-center' src={`${process.env.PUBLIC_URL}/images/sj2.png`} />
						</div>
					</div>
				</div>
			</div></div>
		)
	}
}
export default Resource;



// WEBPACK FOOTER //
// ./src/components/resources/sjbanner.jsx